import React from 'react';
import AceEditor from 'react-ace';

import 'brace/mode/json';
import 'brace/theme/twilight';

export default function SyntaxHighlighter({ content, language }) {
    return (
        <AceEditor
            mode={ language }
            theme="twilight"
            value={ content }
            width="100%"
            fontSize="16px"
        />
    );
}
